import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'giveaway-gen',
  templateUrl: './GiveawayGen.component.html',
  styleUrls: ['./GiveawayGen.component.css']
})
export class GiveawayGenComponent implements OnInit {

	constructor() { }

	list: any[] = [];
	individualentries: any[] = [];
	winningNumbers: any[] = [];
	totalEntries: number = 0;
	totalNames: number = 0;
	nameEntry = "";
	parsedArray: any[] = [];
	message: string = "";

	ngOnInit() {
		//this.loadList();
	}

	loadList(){
		this.list.push({Name: 'Corey', numberofEntries: 5 });
		this.list.push({Name: 'Dan', numberofEntries: 3 });
		this.list.push({Name: 'Carl', numberofEntries: 1 });
		this.SetIndividualentries();
	}

	SetIndividualentries(){
		this.list.forEach(entry => {
			for(let e = 0;e<entry.numberofEntries;e++){
				this.individualentries.push({Name: entry.Name, rng: ''});
			}			
		});
		this.getTotals();
	}

	getTotals(){
		this.totalEntries = 0;
		this.totalNames = 0;

		let tempNameArray = [];
		this.list.forEach(entry => {
			//if(!tempNameArray.find(name => {return name == entry.Name})){
			//	this.totalNames = this.totalNames + 1;
			//	tempNameArray.push(entry.Name);
			//}
			//console.log(entry.Name);
			this.totalNames = this.totalNames + 1;
			this.totalEntries  = this.totalEntries + entry.numberofEntries;
		});
	}

	SetRaffleNumber(){
		this.message = "";
		if(this.list.length > 0)
		{
			this.individualentries = [];
			this.winningNumbers = [];
			this.totalEntries = 0;
			this.totalNames = 0;
			this.SetIndividualentries();
			let ExistingNumbers = [];
			this.individualentries.forEach(entry => {
				let number = 0;
				while(number == 0){
					let num = this.randomIntFromInterval(1, this.totalEntries);
					if(!ExistingNumbers.find(en => {return en == num})){
						ExistingNumbers.push(num);
						number = num;
					}
					entry.rng = number;
				}			
			});
		}
		else {
			this.message = "No Entries have been added to the list, please load the entry list.";
		}
	}
	randomIntFromInterval(min,max) // min and max included
	{
	    return Math.floor(Math.random()*(max-min+1)+min);
	}

	SelectWinningNumbers(){
		let number = 0;
		this.winningNumbers = 
		[{Id: 1, Place: '1st', Name: '', NumberPulled: 0}
		,{Id: 2, Place: '2nd', Name: '', NumberPulled: 0}
		,{Id: 3, Place: '3rd', Name: '', NumberPulled: 0}];


		this.winningNumbers.forEach(calledNumber => {
			let number = 0;
			while(number == 0){
				let num = this.randomIntFromInterval(1, this.totalEntries);
				if(!this.winningNumbers.find(win => {return win.NumberPulled == num}))
				{
					let entryItem = this.individualentries.find(entry => {return entry.rng == num});
					if(!this.winningNumbers.find(name => {return name.Name == entryItem.Name})){
						calledNumber.NumberPulled = num;
						number = num;
					}	
				}
			}
			let entryItem = this.individualentries.find(entry => {return entry.rng == calledNumber.NumberPulled});
			if(entryItem){
				calledNumber.Name = entryItem.Name;
			}
			
		});
	}

	resetNameEntry(){
		this.nameEntry = "";
	}

	parseEntries(){
		let cleanString = this.nameEntry.replace(/(\r\n|\n|\r)/gm, "");
		this.parsedArray = cleanString.split(',');

		this.list = [];
		this.parsedArray.forEach(item => {
			if(item != ""){
				let temp = item.split(':');
				if(!isNaN(temp[1])){
					this.list.push({Name: temp[0], numberofEntries: Number(temp[1])})
				}
			}
		});
		console.log(this.list);
	}

}



// WEBPACK FOOTER //
// ./src/app/GiveawayGen/GiveawayGen.component.ts